import React, { useEffect, useState } from 'react';
import styles from './CreateConnection.module.scss';
import RoundedButton from '../../../../components/RoundedButton/RoundedButton';
import DropdownSelect from '../../../../components/dropdownSelect';
import { getRenderControl } from '../../../../components/SingleControlCustom/getRenderControl';
import { getDocOptionsSelect } from '../../utils/getDocOptionsSelect';
import { useDispatch } from 'react-redux';
import { actions } from '../../store/actions/new-document.actions';

const CreateConnection = ({
  allowedEntity,
  isAllowedEntityFetching,
  onClose,
}) => {
  const [value, setValue] = useState(null);

  const dispatch = useDispatch();

  const options = getDocOptionsSelect(allowedEntity);

  const handleCreateConnection = () => {
    dispatch(actions.openCreateDocument());

    onClose();
  };

  useEffect(() => {
    if (allowedEntity && allowedEntity?.length === 1) {
      setValue(allowedEntity[0].id);
    }
  }, [allowedEntity]);

  return (
    <div className={styles.root}>
      <DropdownSelect
        disabled={isAllowedEntityFetching}
        loading={isAllowedEntityFetching}
        multiple={false}
        options={options}
        onChange={setValue}
        value={value}
        renderControl={getRenderControl({
          options,
          isClear: false,
          value,
        })}
      />
      <RoundedButton
        text="Создать"
        className={styles.createBtn}
        disabled={!value}
        onClick={handleCreateConnection} // сейчас идет связывание только объектов
      />
    </div>
  );
};

export default CreateConnection;
